
import { GraduationCap, Book, Target, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Training = () => {
  const { t } = useTranslation('training');

  const features = [
    {
      title: t('features.simplify.title'),
      description: t('features.simplify.description'),
      icon: <CheckCircle2 className="w-5 h-5 text-brand-orange" />
    },
    {
      title: t('features.translate.title'),
      description: t('features.translate.description'),
      icon: <Book className="w-5 h-5 text-brand-orange" />
    },
    {
      title: t('features.adjust.title'),
      description: t('features.adjust.description'),
      icon: <Target className="w-5 h-5 text-brand-orange" />
    }
  ];

  return (
    <div className="bg-background">
      {/* Hero Section */}
      <section className="relative min-h-[90vh] flex items-center">
        <div className="absolute inset-0 -z-10">
          <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/8),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/4),transparent)]" />
          <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/5),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/3),transparent)]" />
        </div>
        
        <div className="container-custom relative z-10 py-24">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-blue/10 dark:bg-brand-blue/5 text-brand-blue dark:text-brand-orange mb-8">
              <GraduationCap className="w-5 h-5" />
              <span className="text-sm font-medium">{t('badge')}</span>
            </div>
            
            <h1 className="text-5xl sm:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange leading-[1.2] pb-4">
              {t('title')}
            </h1>
            
            <p className="text-xl text-muted-foreground mb-12 max-w-2xl mx-auto">
              {t('description')}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact?type=demo" 
                className="inline-flex items-center px-6 py-3 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                {t('cta.demo')}
              </Link>
              <Link
                to="/contact" 
                className="inline-flex items-center px-6 py-3 rounded-lg border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                {t('cta.contact')}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-card">
        <div className="container-custom">
          <div className="max-w-6xl mx-auto">
            <div className="grid sm:grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="group bg-background rounded-xl p-8 hover:shadow-xl transition-all duration-300 border border-border hover:-translate-y-1"
                >
                  <div className="flex items-center justify-center mb-6">
                    <div className="p-3 bg-brand-orange/10 dark:bg-brand-orange/5 rounded-xl group-hover:scale-110 transition-transform">
                      {feature.icon}
                    </div>
                  </div>
                  <h3 className="text-xl font-medium text-brand-blue dark:text-brand-orange mb-4 text-center group-hover:text-[#8B5CF6] transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground text-center">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-16 text-center">
              <p className="text-xl text-brand-blue dark:text-brand-orange mb-8 max-w-3xl mx-auto">
                {t('result')}
              </p>
              <Link
                to="/contact?type=demo"
                className="inline-flex items-center px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl text-lg"
              >
                {t('cta_discover')}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Training;
